/**
 * Common invitation status type used across the application
 * Used for Stock Owners, Admins, and other entities with invitation flow
 * 
 * Note: null means no invitation has been sent yet (show "Send Invite" button)
 */
export type InviteStatus = 'active' | 'pending' | 'inactive' | 'deactivated' | 'revoked' | 'rejected' | 'expired' | null;

/**
 * Invite Status ID enum for UI display (colors and icons)
 * Used by UltimateDataTable columnStatus function
 */
export enum InviteStatusId {
  ACTIVE = 0,       // Green - User accepted invitation and is active
  INACTIVE = 1,     // Red - User never accepted invitation
  PENDING = 2,      // Blue - Pending acceptance (invitation sent or waiting)
  DEACTIVATED = 3   // Gray/Black - User was active but has been deactivated
}

/**
 * Interface for entities that have meta information about invitation
 */
export interface IInviteMeta {
  approvedAt?: string;
  invitationStatus?: 'pending' | 'accepted' | 'rejected';
  expiredAt?: string;
}

